if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.secondarysubmitButton = this.form.querySelector('.secondry_atc_btn');

        this.card_product_variant_radios = this.form.querySelectorAll('.card-product-quick-addtocart-radio input[name="id"], .quick-add-mob-addtocart-radio input[name="id"]');

        if (this.card_product_variant_radios.length > 0) {
          this.card_product_variant_radios.forEach(e => {
            e.addEventListener('change', this.onSubmitHandler.bind(this));
          })
        }

        if (this.secondarysubmitButton) {
          this.secondarysubmitButtonText = this.secondarysubmitButton.querySelector('.secondary_atc_btn_textcontent');
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (evt.target.closest('.variant-radio-option')){
          evt.target.closest('.variant-radio-option')?.querySelector('.loading__spinner')?.classList.remove('hidden');
        } else {
          this.querySelector('.loading__spinner').classList.remove('hidden');
        }
        this.secondarysubmitButton?.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.secondarysubmitButton?.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (evt.target.closest('.variant-radio-option')){
              evt.target.closest('.variant-radio-option')?.querySelector('.loading__spinner')?.classList.add('hidden');
              evt.target.closest('.variant-radio-option').querySelector('input[name="id"]').checked = false;
            }
            if (evt.target.closest('.quick-add-mob__popup')) {
              evt.target.closest('.quick-add-mob__popup')?.querySelector('[data-quick-add-close]')?.click();
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.secondarysubmitButton?.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          if (text && this.secondarysubmitButtonText) this.secondarysubmitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.secondarysubmitButton?.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          if (this.secondarysubmitButtonText) this.secondarysubmitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


/******************************************************************* 
** Product card swatch click handling for sibling products JS
*******************************************************************/


// Global Cache
window.ProductCardCache = window.ProductCardCache || {};

class ProductSiblingSwitcher {

  constructor() {

    this.cache = window.ProductCardCache;

    this.init();

  }

  init() {

    this.bindEvents();

    window.addEventListener(
      'load',
      () => this.preloadVisibleCards()
    );

  }

  bindEvents() {

    document.addEventListener(
      'click',
      this.handleSwatchClick.bind(this)
    );

  }

  async handleSwatchClick(event) {

    const swatch =
      event.target.closest(
        '.js-sibling-swatch'
      );

    if (!swatch) return;

    event.preventDefault();

    const handle =
      swatch.dataset.productHandle;

    const url =
      swatch.dataset.productUrl;

    const card =
      swatch.closest(
        '.product-card-wrapper'
      );

    if (
      !handle ||
      !url ||
      !card
    ) {
      return;
    }

    card.classList.add(
      'product-card-loading'
    );

    try {

      let html;

      if (this.cache[handle]) {

        html =
          this.cache[handle];

      } else {

        html =
          await this.fetchCard(
            handle,
            url
          );

      }

      if (!html) {

        card.classList.remove(
          'product-card-loading'
        );

        return;
      }

      this.replaceCard(
        card,
        html
      );

    } catch (error) {

      console.error(
        'Sibling Switch Error',
        error
      );

      window.location.href = url;

    }

  }

  async fetchCard(
    handle,
    productUrl
  ) {

    const response =
      await fetch(
        `${productUrl}?section_id=product-card-render`
      );

    if (!response.ok) {

      throw new Error(
        'Card Fetch Failed'
      );

    }

    const html =
      await response.text();

    const doc =
      new DOMParser()
      .parseFromString(
        html,
        'text/html'
      );

    const card =
      doc.querySelector(
        '.product-card-wrapper'
      );

    if (!card) {

      return null;

    }

    const cardHTML =
      card.outerHTML;

    this.cache[handle] =
      cardHTML;

    return cardHTML;

  }

  replaceCard(
    oldCard,
    html
  ) {

    const temp =
      document.createElement(
        'div'
      );

    temp.innerHTML =
      html;

    const newCard =
      temp.querySelector(
        '.product-card-wrapper'
      );

    if (!newCard) {

      oldCard.classList.remove(
        'product-card-loading'
      );

      return;

    }

    oldCard.replaceWith(
      newCard
    );

    this.afterSwap();

  }

  afterSwap() {

    this.initJudgeMe();

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            this.initGloboPreorder();
        });
    });

    this.triggerThemeEvents();

  }

  initJudgeMe() {

    if (
      window.jdgm &&
      typeof window.jdgm.initializeWidgets
      === 'function'
    ) {

      window.jdgm.initializeWidgets();

    }

  }

  initGloboPreorder() {

    if (
        !window.Globo ||
        !window.Globo.Preorder
    ) {
        return;
    }

    try {

        Globo.Preorder.init(
            GloboPreorderParams
        );

        Globo.Preorder.initPreorder();

    } catch (error) {

        console.error(
            error
        );

    }
  }

  triggerThemeEvents() {

    document.querySelectorAll("img[data-src], img[data-srcset], source[data-srcset]").forEach((e) => {
        let datasrcset = e.dataset.srcset;
        if(datasrcset != null) {
            e.srcset = datasrcset;
            e.removeAttribute('data-srcset');
        }

        let datasrc = e.dataset.src;
        if(datasrc != null) {
            e.src = datasrc;
            e.removeAttribute('data-src');
        }
    });

    document.dispatchEvent(
      new CustomEvent(
        'product-card-swapped'
      )
    );

  }

  preloadVisibleCards() {

    if (
      !(
        'IntersectionObserver'
        in window
      )
    ) {
      return;
    }

    const cards =
      document.querySelectorAll(
        '.product-card-wrapper'
      );

    const observer =
      new IntersectionObserver(
        entries => {

          entries.forEach(
            entry => {

              if (
                !entry.isIntersecting
              ) {
                return;
              }

              this.preloadCardSiblings(
                entry.target
              );

              observer.unobserve(
                entry.target
              );

            }
          );

        },
        {
          rootMargin:
            '300px'
        }
      );

    cards.forEach(
      card =>
        observer.observe(card)
    );

  }

  preloadCardSiblings(card) {

    const swatches =
      card.querySelectorAll(
        '.js-sibling-swatch'
      );

    swatches.forEach(
      swatch => {

        const handle =
          swatch.dataset
          .productHandle;

        const url =
          swatch.dataset
          .productUrl;

        if (
          !handle ||
          this.cache[handle]
        ) {
          return;
        }

        const preload =
          () => {

            this.fetchCard(
              handle,
              url
            ).catch(() => {});

          };

        if (
          'requestIdleCallback'
          in window
        ) {

          requestIdleCallback(
            preload
          );

        } else {

          setTimeout(
            preload,
            500
          );

        }

      }
    );

  }

}

new ProductSiblingSwitcher();


/******************************************************************* 
** Product card swatch click handling for sibling products JS END
*******************************************************************/

